module.exports = __webpack_public_path__ + "img/Apple.791c11ad.svg";